<template>
  <div class="personal-loan-interest-rate">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t('list.showPersonalLoanInterestRate') }}
        </h3>
      </div>
      <div class="box-body">
        <personal-loan-interest-rate-form :editable="false" />
      </div>
    </div>
  </div>
</template>

<script>
import PersonalLoanInterestRateForm from './Form'

export default {
  name: 'Show',
  metaInfo () {
    return {
      title: this.$t('string.showPurchasingLoanInterestRate'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  components: { PersonalLoanInterestRateForm }
}
</script>

<style scoped>

</style>
